import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import * as moment from "moment";
import { OBJECT_TYPE, PRIORITIES, STATUS } from "../../@core/data/default-list";
import { User } from "../../@core/data/users";
import { Customer } from "../../models/customer.model";
import { Employee } from "../../models/employee.model";
import { Person } from "../../models/person.model";
import { Project } from "../../models/project.model";
import { Receipt } from "../../models/receipt.model";
import { Supplier } from "../../models/supplier.model";
import WorkingTask, { TaskProcessors } from "../../models/working-task.model";
import { NotificationService } from "../../services/notifications.service";
import { WorkingTaskService } from "../../services/working-task.service";

import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogLinkReceiptComponent } from "../dialog-link-receipt/dialog-link-receipt.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { environment } from "../../../environments/environment";
import { CustomerService } from "../../services/customer.service";
import { DialogPrintWorkingTaskComponent } from "../dialogs/dialog-print-working-task/dialog-print-working-task.component";
import { ShopService } from "../../services/shop.service";

@Component({
  selector: "ngx-dialog-working-task",
  templateUrl: "dialog-working-task.component.html",
  styleUrls: ["dialog-working-task.component.scss"],
})
export class DialogWorkingTaskComponent implements OnInit {
  @Input() shopId: string;
  @Input() header?: string;
  @Input() uid: string;
  @Input() user?: User;
  @Input() mode: string; //new - edit - view
  @Input() task?: WorkingTask = new WorkingTask();

  @Input() users?: Person[];
  @Input() customers?: Customer[];
  @Input() employees?: Employee[];
  @Input() suppliers?: Supplier[];
  @Input() persons?: Person[];
  @Input() projects?: Project[];

  @Input() customer?: Customer;

  taskOriginal: WorkingTask = new WorkingTask();

  statusList = STATUS;
  priorities = PRIORITIES;
  objectTypes = OBJECT_TYPE;
  trees: Set<string> = new Set([]);

  locked: boolean = false;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info"; //info - content
  view = "main"; //main / replies

  isEditDesc: boolean = false;
  bkDescription: string = "";

  processorEmp: Employee;
  processorRole: string = "";

  constructor(
    protected ref: NbDialogRef<DialogWorkingTaskComponent>,
    private workingTaskService: WorkingTaskService,
    private dialogService: NbDialogService,
    private notiService: NotificationService,
    private customerService: CustomerService,
    private shopService: ShopService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    if (this.task.tags && this.task.tags.length > 0) {
      var trees = new Set([]);
      this.task.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("CV");
    }
    if (!this.task.sourceType || this.task.sourceType == "") {
      this.task.sourceType = "document";
    }

    if (this.task.coverUrl && this.task.coverUrl != "") {
      this.imageURL = this.task.coverUrl;
    }
    if (this.task.imagesUrl && this.task.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.task.imagesUrl);
    }
    if (!this.task.content) {
      this.task.content = "";
    }
    this.receiptLinked = this.task.receipt ? true : false;

    this.view = this.mode === "view" ? "replies" : "main";
    if (this.mode === "new") {
      this.isEditDesc = true;
      this.initNewData();
    } else {
      this.taskOriginal = _.clone(this.task);
    }

    console.log("DialogWorkingTaskComponent/ngOnInit:", this.task);

    var duration = moment.duration(
      moment().diff(moment(this.taskOriginal.issueDate))
    );
    const days = duration.asDays();
    if (days > environment.lockedDays && !this.user.moderator) {
      this.locked = true;
    }

    if (!this.customers || this.customers.length === 0) {
      this.customers = this.customerService.customers;
    }
  }

  initNewData() {
    this.mode = "new";
    let newProd = new WorkingTask();
    delete newProd.id;
    newProd.status = 0;
    newProd.priority = 0;
    newProd.issueDate = new Date();
    newProd.shopId = this.shopId;

    newProd.title = "";
    newProd.description = "";
    newProd.assignBy = this.task.assignBy ? this.task.assignBy : this.uid;
    newProd.assignee = this.task.assignee ? this.task.assignee : this.user;

    newProd.objectType = this.task.objectType ? this.task.objectType : "";
    newProd.customerId = this.task.customerId ? this.task.customerId : "";
    newProd.customerName = this.task.customerName ? this.task.customerName : "";
    newProd.supplierId = this.task.supplierId ? this.task.supplierId : "";
    newProd.supplierName = this.task.supplierName ? this.task.supplierName : "";
    newProd.employeeId = this.task.employeeId ? this.task.employeeId : "";
    newProd.employeeName = this.task.employeeName ? this.task.employeeName : "";

    this.task = newProd;
    this.taskOriginal = _.clone(this.task);
    console.log("DialogWorkingTaskComponent/initNewData:", this.task);
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.task);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  submit(newData: boolean = true) {
    this.task.title = this.task.title ? this.task.title.trim() : "";

    this.task.issueDate = this.task.issueDate
      ? this.task.issueDate
      : moment().startOf("day").toDate();

    this.task.issueDateYear = this.task.issueDate.getFullYear();
    this.task.issueDateMonth = this.task.issueDate.getMonth() + 1;
    this.task.issueDateDay = this.task.issueDate.getDate();
    this.task.issueDateWeekDay = this.task.issueDate.getDay();
    this.task.issueDateHours = this.task.issueDate.getHours();
    this.task.issueDateMinutes = this.task.issueDate.getMinutes();
    this.task.issueDateSeconds = this.task.issueDate.getSeconds();

    this.task.dueDate =
      this.task.dueDate >= this.task.issueDate
        ? this.task.dueDate
        : moment(this.task.issueDate).endOf("day").toDate();

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.task.tags = tags;
    this.task.coverUrl = this.task.coverUrl ? this.task.coverUrl : "";
    this.task.content = this.task.content ? this.task.content : "";
    this.task.videoUrl = this.task.videoUrl ? this.task.videoUrl : "";
    this.task.imagesUrl = this.task.imagesUrl ? this.task.imagesUrl : [];

    if (this.customer && this.customer.id !== "") {
      this.task.customerId = this.customer.id;
    }

    this.task.customerId = this.task.customerId ? this.task.customerId : "";
    const customer = _.find(this.customers, { id: this.task.customerId });
    this.task.customerName = customer
      ? customer.fullName
      : this.task.customerName
      ? this.task.customerName
      : "";

    this.task.supplierId = this.task.supplierId ? this.task.supplierId : "";
    const supplier = _.find(this.suppliers, { id: this.task.supplierId });
    this.task.supplierName = supplier
      ? supplier.fullName
      : this.task.supplierName
      ? this.task.supplierName
      : "";

    this.task.employeeId = this.task.employeeId ? this.task.employeeId : "";
    const employee = _.find(this.employees, { id: this.task.employeeId });
    this.task.employeeName = employee
      ? employee.fullName
      : this.task.employeeName
      ? this.task.employeeName
      : "";

    const assign = _.find(this.users, { id: this.task.assignBy });
    if (assign) {
      this.task.assignName = assign.fullName;
      const assignee: User = {
        uid: assign.id,
        displayName: assign.fullName,
        email: assign.email,
      };
      this.task.assignee = assignee;
    } else if (!this.task.assignBy || this.task.assignBy == "") {
      this.task.assignBy = this.uid;
      this.task.assignName = this.user.displayName;
      this.task.assignee = this.user;
    }

    //assignee
    this.mode === "new" ? this.create(newData) : this.edit(newData);
  }

  create(newData: boolean) {
    if (!this.submitted) {
      this.loading = true;
      this.submitted = true;

      this.workingTaskService
        .create(this.task)
        .then((data) => {
          this.task = data;

          this.loading = false;
          this.submitted = false;

          if (newData) {
            this.initNewData();
          } else {
            this.ref.close(this.task);
            this.showToast("success", "Thêm mới công việc", "thành công");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  edit(newData: boolean) {
    if (!this.submitted) {
      this.loading = true;
      this.submitted = true;

      console.log("DialogWorkingTaskComponent/edit:", this.task);

      this.workingTaskService
        .update(this.task)
        .then((data) => {
          this.loading = false;
          this.submitted = false;

          this.edited = true;
          if (newData) {
            this.initNewData();
          } else {
            this.ref.close(this.task);
            this.showToast("success", "Cập nhật công việc", "thành công");
          }

          //notification
          //this.sendNotification();

          //sync data to offline DB
          this.task.updatedOn = new Date();
          this.workingTaskService.sync(this.task);
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
          this.submitted = false;
          this.showToast("warning", "Cập nhật công việc", "thất bại");
        });
    }
  }

  remove() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.workingTaskService
            .delete(this.shopId, this.task.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.task.isDeleted = true;

              //notification
              this.sendNotification();

              this.ref.close(this.task);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  moveToTrash() {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn muốn hủy công việc này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.submitted = true;

          this.workingTaskService
            .setActive(this.shopId, this.task.id, this.task.issueDate, false)
            .then((result) => {
              this.loading = false;
              this.submitted = false;

              this.task.isActive = false;

              //notification
              this.sendNotification();

              this.ref.close(this.task);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.task.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.task.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.task.imagesUrl) {
      this.task.imagesUrl = [];
    }
    this.task.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.task.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  //Task Processors
  addProcessor() {
    if (this.processorEmp) {
      const emp = new Employee();
      emp.id = this.processorEmp.id;
      emp.fullName = this.processorEmp.fullName;
      emp.firstName = this.processorEmp.firstName;
      emp.lastName = this.processorEmp.lastName;
      emp.email = this.processorEmp.email;
      emp.mobile = this.processorEmp.mobile;

      const taskProcessor = new TaskProcessors();
      taskProcessor.employee = emp;
      taskProcessor.role = this.processorRole;

      if (this.task.processors && this.task.processors.length >= 0) {
        this.task.processors.push(taskProcessor);
      } else {
        this.task.processors = [taskProcessor];
      }

      this.processorRole = "";
    }
  }

  removeProcessor(item) {
    const index = this.task.processors.indexOf(item);
    if (index > -1) {
      this.task.processors.splice(index, 1);
    }
  }

  // control event
  selectAssign(value) {
    if (value) {
      this.task.assignBy = value.objectId;
      this.task.assignName = value.objectName;
    }
  }

  objectChange(value) {
    console.log("objectChange:", value);
    if (value) {
      switch (value.objectType) {
        case "customer":
          this.task.customerId = value.objectId;
          this.task.customerName = value.objectName;
          this.task.supplierId = "";
          this.task.supplierName = "";
          this.task.employeeId = "";
          this.task.employeeName = "";
          break;
        case "supplier":
          this.task.customerId = "";
          this.task.customerName = "";
          this.task.supplierId = value.objectId;
          this.task.supplierName = value.objectName;
          this.task.employeeId = "";
          this.task.employeeName = "";
          break;
        case "employee":
          this.task.customerId = "";
          this.task.customerName = "";
          this.task.supplierId = "";
          this.task.supplierName = "";
          this.task.employeeId = value.objectId;
          this.task.employeeName = value.objectName;
          break;
        case "project":
          this.task.projectId = value.objectId;
          this.task.projectName = value.objectName;
          break;

        default:
          this.task.customerId = "";
          this.task.customerName = "";
          this.task.supplierId = "";
          this.task.supplierName = "";
          this.task.employeeId = "";
          this.task.employeeName = "";
          break;
      }
    }
  }

  editDescription() {
    this.isEditDesc = true;
    this.bkDescription = this.task.description;
  }
  closeDescription() {
    this.isEditDesc = false;
    this.task.description = this.bkDescription;
  }

  saveDescription() {
    this.isEditDesc = false;

    this.loading = true;
    this.submitted = true;
    this.workingTaskService
      .updateDescription(this.shopId, this.task.id, this.task.description)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        //sync data to offline DB
        this.task.updatedOn = new Date();
        this.workingTaskService.sync(this.task);
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật công việc chi tiết", "thất bại");
      });
  }

  receiptLinked: boolean = false;
  linkReceipt() {
    this.dialogService
      .open(DialogLinkReceiptComponent, {
        context: {
          header: `Xin vui lòng chọn phiếu bán hàng.`,
          shopId: this.shopId,
          uid: this.uid,
          isClosed: true,
          customerId: this.task.customerId,
        },
      })
      .onClose.subscribe((value) => {
        console.log("linkReceipt:", value);
        if (value) {
          this.task.receipt = new Receipt();
          this.task.receipt.id = value.id;
          this.task.receipt.issueDate = value.issueDate;
          this.task.receipt.code = value.code;
          this.task.receipt.note = value.note;
          this.task.receipt.receiptDetails = value.receiptDetails;
          this.task.receipt.totalQuantity = value.totalQuantity;
          this.task.receipt.detailAmount = value.detailAmount;
          this.task.receipt.discountAmount = value.discountAmount;
          this.task.receipt.totalAmount = value.totalAmount;
          this.receiptLinked = true;
        }
      });
  }
  unlinkReceipt() {
    this.receiptLinked = false;
    if (this.task.receipt) {
      delete this.task.receipt;
    }
  }

  print() {
    this.dialogService
      .open(DialogPrintWorkingTaskComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          task: this.task,
          shop: this.shopService.shop,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }

  //notification
  private sendNotification() {
    let strChanged: string = ``;
    if (this.taskOriginal.title !== this.task.title) {
      strChanged += `\n- Đổi tên: ${this.task.title}`;
    }
    if (this.taskOriginal.description !== this.task.description) {
      strChanged += `\n- Cập nhật mô tả chi tiết`;
    }
    if (this.taskOriginal.status !== this.task.status) {
      strChanged += `\n- Cập nhật trạng thái: ${
        this.statusList[this.task.status].title
      }`;
    }
    if (this.taskOriginal.priority !== this.task.priority) {
      strChanged += `\n- Thay đổi phân loại: ${
        this.priorities[this.task.priority].title
      }`;
    }
    if (this.taskOriginal.customerName !== this.task.customerName) {
      strChanged += `\n- Cập nhật khách hàng: ${this.task.customerName}`;
    }
    if (this.taskOriginal.supplierName !== this.task.supplierName) {
      strChanged += `\n- Cập nhật nhà cung cấp: ${this.task.supplierName}`;
    }
    if (this.taskOriginal.employeeName !== this.task.employeeName) {
      strChanged += `\n- Cập nhật nhân viên: ${this.task.employeeName}`;
    }
    if (this.taskOriginal.projectName !== this.task.projectName) {
      strChanged += `\n- Cập nhật dự án: ${this.task.projectName}`;
    }
    if (this.taskOriginal.assignName !== this.task.assignName) {
      strChanged += `\n- Cập nhật người thực hiện: ${this.task.assignName}`;
    }
    if (
      this.taskOriginal.issueDate?.toDateString() !==
      this.task.issueDate?.toDateString()
    ) {
      strChanged += `\n- Cập nhật ngày thực hiện: ${this.task.issueDate?.toDateString()}`;
    }
    if (
      this.taskOriginal.dueDate.toDateString() !==
      this.task.dueDate.toDateString()
    ) {
      strChanged += `\n- Cập nhật hạn hoàn thành: ${this.task.dueDate.toDateString()}`;
    }
    if (this.taskOriginal.isActive !== this.task.isActive) {
      strChanged += `\n- Hủy công việc`;
    }
    if (this.taskOriginal.isDeleted !== this.task.isDeleted) {
      strChanged += `\n- Xóa công việc`;
    }

    if (this.task.assignBy != this.uid) {
      this.notiService.create(
        "Công việc",
        "working-tasks",
        this.task.id,
        this.task.id,
        strChanged,
        this.task.title,
        this.task.assignBy,
        `/working-tasks/${this.task.id}`,
        ""
      );
    }

    if (this.task.createdBy != this.task.assignBy) {
      this.notiService.create(
        "Công việc",
        "working-tasks",
        this.task.id,
        this.task.id,
        strChanged,
        this.task.title,
        this.task.createdBy,
        `/working-tasks/${this.task.id}`,
        ""
      );
    }
  }
}
